export default __webpack_public_path__ + "static/media/image-banner-w@3x.e2fe33b9.webp";